import { Navigate, useParams, useSearchParams } from 'react-router';

function JoinPage() {
  const { referralCode } = useParams();
  const [searchParams] = useSearchParams();

  return (
    <Navigate
      replace
      to={`/register?referral_code=${referralCode}&${searchParams.toString()}`}
    />
  );
}

export default JoinPage;
